Vendd.Scripts.load(function () {
    var $form = $('.x-registration-form'), form, formData, $loyaltyErrorWrapper = $('.loyalty-error-container'), loyaltyRegistrationUrl;

    if ($form.length < 1) return;

    form = $form.get(0);

    //get verification token
    var token = getQueryStringValueByName("vtoken");
    if (token.length > 0) {
        $('.js-error', $form).hide();
        $('.js-exists', $form).hide();
        $('.js-content', $form).hide();
        $('.js-success', $form).show();
        $('.js-need-verification', $form).hide();

        //clear user model
        Vendd.User.ClearClientModel();
        //redirect
        window.location = '/';
    }

    var loyaltyMemberCardNumberIsValid = true;
    var loyaltyMemberCardNumberIsEnabled = $form.data('loyaltymembercardnumberisenabled');
    var verifyemail = $form.data('verifyemail').toString().toLowerCase() === 'true';
    var useEmailAsLoginName = $form.data('useemailasloginname').toString().toLowerCase() === 'true';

    importEmailForRegistration();

    formData = {
        "title": $("option:selected", 'select[name=title]').text(),
        "firstName": $('input[name="firstName"]').val(),
        "lastName": $('input[name="lastName"]').val(),
        "email": $('input[name="email"]').val().trim(),
        "username": ($('input[name="username"]').length > 0 ? $('input[name="username"]').val() : ''),
        "password": "",
        "passwordConfirmation": "",
        "newsletter": false,
        "reCaptchaCode": "",
        "redirectUrl": $form.data('redirect') || "",
        "phone": $('input[name="phone"]').val(),
        "mobilephone": "", //$('input[name="mobilephone"]').val()
        "socialSecurityNumber": $('input[name="socialSecurityNumber"]').val(),
        "birthdate": "",
        "registerToLoyalty": false,
        "isLoyaltyMember": false,
        "loyaltyRequest": false,
        "loyaltyMemberId": "",
        "ReceiveEinvoice": null,
        "alreadyRegisteredToLoyalty": false,
        "loyaltyMemberCardNumber": "",
        "postalCode": "",
        "registrationSetData": registrationSetData || null
    };

    var areas = [];
    var registrationSetData = [];

    // reCAPTCHA
    var captchaWidgetId;
    var captchaId = "registrationCaptcha";
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
        }
    };

    $form.on('click', '.js-password-reveal', function (e) {
        e.preventDefault();
        if ($(this).hasClass('shown')) {
            $(this).removeClass('shown').siblings('input').prop('type', 'password');
        } else {
            $(this).addClass('shown').siblings('input').prop('type', 'text');
        }
    });

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        }
        else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
        // If a verify attempt has been made with a particular token, it cannot be used again. 
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.getAreasForPostCode = function (envelope) {

        areas = envelope.message.data;

        //validate postal code.
        if (valOpts.postalCode && valOpts.postalCode.isValidPostalCode) {
            valOpts.postalCode.isValidPostalCode.config.areas = areas;
        }
        rf.validateField("postalCode");
    };

    form.setRegistrationData = function () {

        var $sets = $('.js-registration-set', $form);

        if ($sets.length < 1) return;

        //init array
        registrationSetData = [];

        $.each($sets, function (e, set) {
            var $set = $(set);

            var setData = {
                Name: $set.data('set-name'),
                Id: $set.data('set-id'),
                Values: []
            }

            $.each($('input[type="checkbox"]', $set), function (e, input) {
                if ($(input).is(':checked')) {
                    var setValues = {
                        Id: $(input).data('id'),
                        Name: $(input).data('name')
                    }

                    setData.Values.push(setValues); 
                }
            });

            if (setData.Values.length > 0)
                registrationSetData.push(setData);
        });

        if (registrationSetData.length > 0)
            formData.registrationSetData = registrationSetData;
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);
        var response = envelope.message.data;

        if (response.success && response.code === "Registration_OperationSuccesful") {
            //insert consents after registration success
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            }

            $('.js-error', $form).hide();
            $('.js-exists', $form).hide();
            $('.js-content', $form).hide();
            $('.js-need-verification', $form).hide();
            $('.js-success', $form).hide();

            if (verifyemail) {
                $('.js-need-verification', $form).show(); 
            } else {
                $('.js-success', $form).show();
            }

            $('html,body').animate({ scrollTop: 0 }, 300);

            var isLoyaltyActivated = (formData.alreadyRegisteredToLoyalty || formData.registerToLoyalty);
            if (isLoyaltyActivated && formData.mobilephone) {
                loyaltyRegistrationUrl = response.data.LoyaltyRegistrationUrl;
                Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.CheckByMobile(formData.mobilephone));
            }

            form.removeRecaptcha();

            /* Track User Registration */
            if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                    fbq('track', 'CompleteRegistration');
                }
            }
            /* END Track User Registration */

        } else {

            if (response.code === 'Registration_EmailExists') {
                $('.js-error', $form).hide();
                $('.js-exists', $form).show();
                $('html,body').animate({ scrollTop: $('.js-exists', $form).offset().top - 100 }, 300);
            } else {
                $('.js-exists', $form).hide();
                $('.js-error', $form).show();
                $('html,body').animate({ scrollTop: $('.js-error', $form).offset().top - 100 }, 300);
            }

            form.resetRecaptcha();
        }
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        var response = envelope.message.data;
        if (response.code === 'Registration_EmailExists') {
            $('.js-error', $form).hide();
            $('.js-exists', $form).show();
            $('html,body').animate({ scrollTop: $('.js-exists', $form).offset().top - 100 }, 300);
        } else {
            $('.js-exists', $form).hide();
            $('.js-error', $form).show();
            $('html,body').animate({ scrollTop: $('.js-error', $form).offset().top - 100 }, 300);
        }

        form.resetRecaptcha();
    };

    form.submit = function () {
        form.loading(true);

        formData.newsletter = $('#chkNewsletter').prop("checked");
        formData.registerToLoyalty = $('#chkRegisterToLoyaltyPoints').prop("checked");
        formData.alreadyRegisteredToLoyalty = $('#chkAlreadyRegisteredToLoyaltyPoints').prop("checked");

        formData.isLoyaltyMember = $('#isLoyaltyMember').prop("checked");
        formData.loyaltyRequest = $('#loyaltyRequest').prop("checked");

        var einvoiceVal = $("input:radio[name='einvoice']:checked").val();

        if (einvoiceVal === "true") {
            formData.ReceiveEinvoice = true;
        } else if (einvoiceVal === "false") {
            formData.ReceiveEinvoice = false;
        } else {
            formData.ReceiveEinvoice = null;
        }

        form.setRegistrationData();

        $('input:not([type="checkbox"]), textarea:not([name="g-recaptcha-response"])', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
        });

        Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.Register(
            formData.firstName,
            formData.lastName,
            formData.email,
            formData.username,
            formData.password,
            formData.passwordConfirmation,
            formData.newsletter,
            formData.reCaptchaCode,
            formData.redirectUrl,
            formData.phone,
            formData.mobilephone,
            formData.socialSecurityNumber,
            formData.birthdate,
            formData.isLoyaltyMember,
            formData.loyaltyRequest,
            formData.ReceiveEinvoice,
            formData.loyaltyMemberId,
            formData.loyaltyMemberCardNumber,
            formData.postalCode,
            formData.registrationSetData ));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-exists', $form).hide();
        $('.js-success', $form).hide();
        $('.js-need-verification', $form).hide();
        $('.js-content', $form).show();

        $('input[name="firstName"]', $form).val("");
        $('input[name="lastName"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="username"]', $form).val("");
        $('input[name="password"]', $form).val("");
        $('input[name="passwordConfirmation"]', $form).val("");

        $('input[name="phone"]', $form).val("");
        $('input[name="mobilephone"]', $form).val("");
        $('input[name="socialSecurityNumber"]', $form).val("");
        $('input[name="birthdate"]', $form).val("");
        $('input[name="loyaltyMemberCardNumber"]', $form).val("");
        $('input[name="postalCode"]', $form).val("");

        rf.reset();
    };

    form.updatePasswordBar = function (field) {
        var value = field.val();
        var score = Vendd.Helpers.textStrength(value);

        var $passwordStrength = $('#chkPassLabel, #chkPassText');

        $passwordStrength.removeClass(function (i, css) {
            return (css.match(/(^|\s)level\S+/g) || []).join(' ');
        }).addClass('level' + score);
    };

    $(".js-datepicker", $form).datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: "-100:+0",
        maxDate: "0"
    });

    form.setIsRegistered = function (isRegistered) {
        sessionStorage.setItem('LoyaltyIsRegistered', isRegistered);
    };
    $.fn.validationEngine.validations.passwordStrength = Vendd.Validations.passwordStrength;

    //init validation options
    var valOpts = {}, initialValidation = false;

    //add required validations
    $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
        var inputName = $(el).attr('name');
        valOpts[inputName] = { required: inputName + '-required' };
    });

    //add consent validations
    $.each($('div.consent.checkbox[data-required]'), function (e, el) {
        var consentType = $('input', el).attr('name');
        valOpts[consentType] = { checkboxRequired: consentType + '-required' };
    });

    //add email validation
    if ($('input[name="email"]', $form).length > 0) {
        valOpts.email = valOpts.email || {};
        valOpts.email = { ...valOpts.email, ...{ isEmail: 'email-invalid' } };
    }

    //add phone validation
    if ($('input[name="phone"]', $form).length > 0) {
        valOpts.phone = valOpts.phone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            valOpts.phone = { ...valOpts.phone, ...{ isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'phone' } } } };
        } else {
            if (venddProjectConfigs.Account.RegexPhoneValidation) {
                valOpts.phone = { ...valOpts.phone, ...{ isRegexPhone: { validator: 'phone-invalid', config: { regex: venddProjectConfigs.Account.RegexPhoneValue } } } };
            } else {
                valOpts.phone = { ...valOpts.phone, ...{ isPhoneNumber: 'phone-invalid' } };
            }
        }
    }

    //add mobile validation
    if ($('input[name="mobilephone"]', $form).length > 0) {
        valOpts.mobilephone = valOpts.mobilephone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            valOpts.mobilephone = { ...valOpts.mobilephone, ...{ isValidPhoneLocalized: { validator: 'mobilephone-invalid', config: { type: 'mobile' } } } };
        } else {
            if (venddProjectConfigs.Account.RegexMobileValidation) {
                valOpts.mobilephone = { ...valOpts.mobilephone, ...{ isRegexMobile: { validator: 'mobilephone-invalid', config: { regex: venddProjectConfigs.Account.RegexMobileValue } } } };
            } else {
                valOpts.mobilephone = { ...valOpts.mobilephone, ...{ isPhoneNumber: 'mobilephone-invalid' } };
            }
        }
    }

    //add password strength validation
    if ($('input[name="password"]', $form).length > 0) {
        valOpts.password = valOpts.password || {};
        valOpts.password = { ...valOpts.password, ...{ passwordStrength: { validator: 'password-weak', config: { limit: $form.data('pwdstrength') } } } };
    }

    //add confirmation password match validation
    if ($('input[name="passwordConfirmation"]', $form).length > 0) {
        valOpts.passwordConfirmation = valOpts.passwordConfirmation || {};
        valOpts.passwordConfirmation = { ...valOpts.passwordConfirmation, ...{ match: { validator: 'passwordConfirmation-match', matchField: 'password' } } };
    }

    //add social security number validation
    if ($('input[name="socialSecurityNumber"]', $form).length > 0) {
        valOpts.socialSecurityNumber = { isSocialSecurityNumber: 'socialSecurityNumber-invalid' };
    }

    //add postalCode validation
    //if ($('input[name="postalCode"]', $form).length > 0) {
    //    valOpts.postalCode = valOpts.postalCode || {};
    //    valOpts.email = {...valOpts.email, ...{ isValidPostalCode: { validator: 'postalCode-invalid', config: {country: 'GR', areas: areas } } } };
    //}

    var prevLoyaltyMemberCardNumber = '';

    if (loyaltyMemberCardNumberIsEnabled) {
        $('input[name="loyaltyMemberCardNumber"]', $form).on('blur', function () {
            var loyaltyMemberCardNumber = $(this).val();
            var $formRow = $(this).closest('.form-row');
            loyaltyMemberCardNumber = loyaltyMemberCardNumber.replace(/\s/g, '');
            $(this).val(loyaltyMemberCardNumber);
            if (loyaltyMemberCardNumber == '') {
                $('.loyaltyMemberCardNumber-invalid', $formRow).hide();
                $formRow.removeClass('with-error');
                loyaltyMemberCardNumberIsValid = true;
            } else {
                if (loyaltyMemberCardNumber != prevLoyaltyMemberCardNumber) {
                    //omit script tag before ajax call
                    loyaltyMemberCardNumber = omitScriptTag(loyaltyMemberCardNumber);

                    $('.js-submit-button', $form).attr('disabled', 'disabled');
                    Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.GetMemberByLoyaltyNumber(loyaltyMemberCardNumber));
                    prevLoyaltyMemberCardNumber = loyaltyMemberCardNumber;
                }
            }
        });
    }

    var clickedCheckbox;
    var loyaltyCheckboxes = $('.js-loyalty-checkbox .checkbox-wrapper input', $form);
    loyaltyCheckboxes.removeAttr('disabled');

    $('.consent-wrapper', $form).each(function (e, el) {
        var $chkbx = $('.checkbox-wrapper > input', el); 

        $chkbx.off('click').on('click', function () {
            var $this = $(this);

            if (!$this.is(':checked')) {
                var fieldName = $this.attr('name');

                formData[fieldName] = $this.is(':checked');
                rf = $form.data('validationEngine');
                rf.validate(fieldName);
                return;
            }

            var $text = $('.consent-text-wrapper', el);
            $.fancybox.open($text, {
                maxWidth: 900,
                padding: 0,
                modal: true,
                afterShow: function () {
                    var consentForm = $('.js-consent-form');
                    //var scrollContForm = $('.js-scrollbar', consentForm);
                    var closeButton = $('.js-consent-decline-button', consentForm);
                    var acceptButton = $('.js-consent-accept-button', consentForm);

                    //scrollContForm.mCustomScrollbar({
                    //    scrollbarPosition: "outside",
                    //    scrollInertia: 400,
                    //    timeout: 1000,
                    //    theme: "dark-2",
                    //    mouseWheel: { preventDefault: true },
                    //    callbacks: {
                    //        onTotalScrollOffset: 25,
                    //        onTotalScroll: function () {
                    //            consentForm.addClass('has-scrolled');
                    //            $('.js-consent-accept-button', consentForm).prop('disabled', false);
                    //            $('.js-tooltip', consentForm).addClass('hidden');
                    //        },
                    //        onInit: function () {
                    //            $('.js-scroll-btn', consentForm).addClass('show');
                    //        },
                    //        onCreate: function () {
                    //            setTimeout(function () {
                    //                if (scrollContForm.hasClass('mCS_no_scrollbar')) {
                    //                    consentForm.addClass('has-scrolled');
                    //                    $('.js-consent-accept-button', consentForm).prop('disabled', false);
                    //                    $('.js-tooltip', consentForm).addClass('hidden');
                    //                }
                    //            }, 100);
                    //        }
                    //    }
                    //});

                    //$('.js-scroll-btn', consentForm).click(function () {
                    //    scrollContForm.mCustomScrollbar('scrollTo', '-=' + (scrollContForm.height()));
                    //});

                    closeButton.off('click').on('click', function () {
                        //clickedCheckbox.prop("checked", false);
                        //$this.prop("checked", false);
                        $.fancybox.close(true);
                    });
                    acceptButton.off('click').on('click', function () {
                        //clickedCheckbox.prop("checked", true);
                        //$this.prop("checked", true);
                        $.fancybox.close(true);
                    });
                },
                afterClose: function () {

                    var fieldName = $this.attr('name');

                    formData[fieldName] = $this.is(':checked');
                    rf = $form.data('validationEngine');
                    rf.validate(fieldName);
                },
            });
        });
    });

    loyaltyCheckboxes.click(function (e) {
        clickedCheckbox = $(this);
        $('.consent-wrapper.loyalty .checkbox-wrapper > input', $form).trigger('click');
    });

    if (!useEmailAsLoginName) {
        valOpts.username = {
            required: 'username-required'
        };

    }

    $form.validationEngine(valOpts);
    var rf = $form.data('validationEngine');

    $.each($('.consent.checkbox[data-required]', $form), function (e, el) {
        var consentType = $('input', el);
        consentType.on('change', function () {
            rf.validate(consentType.attr('name'));
        });
    });

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val1 = form.validateRecaptcha();
        var val2 = rf.validate();

        if (val1 && val2 && loyaltyMemberCardNumberIsValid) {
            form.submit();
        } else {
            if ($('.form-row.with-error', $form).length > 0) {
                $('html,body').animate({ scrollTop: $('.form-row.with-error', $form).first().offset().top - 100 }, 600);
            }
        }

        initialValidation = true;
    });

    form.checkConsents = function () {
        var data = [];
        var checkboxes = $('.form-row.consent.checkbox', $form);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Registration Form', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        }
    };

    $form.on('change', 'select[name]', function (e) {
        form.setField($(this));
    });

    $form.on('change', '.js-datepicker', function (e) {
        $(this).trigger('keyup');
    });

    $form.on('keyup', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();

            $('.js-submit-button', $form).click();

            return;
        }

        if ($(this).attr('name') === "postalCode") {
            removeWhiteSpaces($(this));
        }

        if ($(this).attr('name') === "password") {
            form.updatePasswordBar($(this));
            rf.validate("passwordConfirmation");
        }

        form.setField($(this)); 
    });

    $form.on('blur', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {

        if ($(this).attr('name') === "password") {
            form.updatePasswordBar($(this));
            rf.validate("passwordConfirmation");
        }

        //validate fields instantly
        if (!initialValidation) {
            if ($(this).attr('name') === "email") {
                rf.validateField("email");
            }

            if ($(this).attr('name') === "phone") {
                rf.validateField("phone");
            }

            if ($(this).attr('name') === "mobilephone") {
                rf.validateField("mobilephone");
            }
        }

        form.setField($(this));
    });

    form.setField = function (field) {
        var fieldName = field.attr('name');
        rf.validate(fieldName);
    };

    $form.on('keyup', 'input[name = "postalCode"]', $.debounce(400, function () {
        var $this = $(this);
        var postalCode = $this.val();

        if (postalCode === null) return;

        Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.GetAreasForPostCode("GR", postalCode, ""));
    }));

    $form.on('click', 'input.single-check', function () {
        $('input.single-check').not(this).prop('checked', false);
        formData.registerToLoyalty = $('#chkRegisterToLoyaltyPoints').prop("checked");
        formData.alreadyRegisteredToLoyalty = $('#chkAlreadyRegisteredToLoyaltyPoints').prop("checked");
        var isLoyaltyRegistered = formData.registerToLoyalty || formData.alreadyRegisteredToLoyalty;
        $('.consent-wrapper', $form).each(function (e, el) {
            var $chkbx = $('.checkbox-wrapper input', el);
            var chkbxId = $chkbx.attr('id');
            if (chkbxId != undefined && chkbxId != "") {
                valOpts = $form.validationEngine();
                formData[chkbxId] = $chkbx.prop("checked");
                valOpts[chkbxId] = isLoyaltyRegistered ? { checkboxRequired: (chkbxId + '-required') } : {};
                $form.validationEngine(valOpts);
            }
            if (isLoyaltyRegistered) {
                $chkbx.removeAttr('disabled').closest('.checkbox-wrapper').removeClass('disabled');
                $form.data('validationEngine').removeField(chkbxId);
                $form.data('validationEngine').addField(JSON.parse("{\"" + chkbxId + "\" : { \"checkboxRequired\" : \"" + chkbxId + "-required\" }}"));
                $chkbx.prop("checked", true);
                $chkbx.on('change', function () {
                    $form.data('validationEngine').validate($chkbx.attr('name'));
                });
            } else {
                $chkbx.attr('disabled', 'disabled').closest('.checkbox-wrapper').addClass('disabled');
                $('.' + chkbxId + '-required', $form).removeClass("error");
                $form.data('validationEngine').removeField(chkbxId);
                $chkbx.prop("checked", false);
                $chkbx.off('change');
            }
        });
    });

    $form.on('click', '.js-clear-loyalty', function () {
        $('input.single-check:checked').prop('checked', false);
    });

    if (venddProjectConfigs.phoneLocalizationEnabled) {
        if ($('input[name="phone"]', $form).length > 0) {
            $('input[name="phone"]', $form).get(0).addEventListener("countrychange", function () {
                formData.phone = $(this).val();
                rf = $form.data('validationEngine');
                rf.validate('phone');
            });
        }
        if ($('input[name="mobilephone"]', $form).length > 0) {
            $('input[name="mobilephone"]', $form).get(0).addEventListener("countrychange", function () {
                formData.mobilephone = $(this).val();
                rf = $form.data('validationEngine');
                rf.validate('mobilephone');
            });
        }
    }

    Vendd.MessageBus.subscribe(Vendd.User.Messages.RegisterSuccess, form, form.onSuccess);

    Vendd.MessageBus.subscribe(Vendd.User.Messages.RegisterFailure, form, form.onFailure);

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.CheckByMobileSuccess, form, function (envelope) {
        var data = envelope.message.data;

        //if status 409 mobile exists in multiple members
        if (data.StatusCode === 409) {
            var loyaltyErrorWrapper = $loyaltyErrorWrapper.get(0);
            $('.js-error', loyaltyErrorWrapper).html(data.ResponseMessage).show();
            $loyaltyErrorWrapper.show(); 

            return;
        }

        form.setIsRegistered(data.StatusCode === 200);
        sessionStorage.setItem('LoyaltyMobilePhone', formData.mobilephone);
        window.location = window.location.origin + data.LoyaltyRegistrationUrl;
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.CheckByMobileFailure, form, function () {
        form.loading(false);
        toastr.error('Something went wrong');
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, form, function (envelope) {

        if (formData.registerToLoyalty || formData.alreadyRegisteredToLoyalty)
            return;

        var returnUrl = decodeURIComponent(LhApp.Function.QueryString.getValueOf('ReturnUrl', window.location.href));
        if (returnUrl) document.location.href = returnUrl;
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetMemberByLoyaltyNumberSuccess, form, function (envelope) {
        var data = envelope.message.data.model.data;
        if (data.ErrorCode) {
            $('.loyaltyMemberCardNumber-invalid', $form).show().closest('.form-row').addClass('with-error');
            loyaltyMemberCardNumberIsValid = false;
        }
        else {
            $('.loyaltyMemberCardNumber-invalid', $form).hide().closest('.form-row').removeClass('with-error');
            loyaltyMemberCardNumberIsValid = true;
        }
        $('.js-submit-button', $form).removeAttr('disabled');
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetMemberByLoyaltyNumberFailed, form, function (envelope) {
        var message = envelope.message.data.model.message;
        toastr.error(message);
        loyaltyMemberCardNumberIsValid = false;
        $('.js-submit-button', $form).removeAttr('disabled');
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetAreasForPostCodeSuccess, form, form.getAreasForPostCode);

    Vendd.MessageBus.publishAsync(form, new Vendd.Widget.Messages.BindControl($form));

});
